export default __webpack_public_path__ + "static/media/thank-you-hearts-top-left.7944dec4.svg";